module.exports = __webpack_public_path__ + "static/media/io4k@2x.6218c1d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gear/display/io4k@2x.png
// module id = 322
// module chunks = 0